<template>
	<Container>
		<Loader v-if="isLoading"></Loader>
		<h2 v-else class="mb-4 font-bold">{{ type }} {{ $t('category') }}:</h2>
		<div class="mb-4">
			<div class="mb-4">
				<label class="block mb-2 font-bolder" for="category_name"
					>{{ $t('category_name') }}:</label
				>
				<input
					type="text"
					v-model="category_name"
					id="category_name"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
				<div v-if="$v.category_name.$dirty">
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.category_name.required"
					>
						{{ $t('name_required') }}
					</div>
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.category_name.maxLength"
					>
						{{ $t('name_validation') }}
					</div>
				</div>
			</div>

			<div class="mb-4">
				<label class="block mb-2" for="currentcountry">País</label>
				<select
					ref="currentcountry"
					id="currentcountry"
					v-model="currentcountry"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				>
					<option
						v-for="(country, index) in countries"
						:value="country.id"
						:key="index"
						:selected="country.id == currentcountry"
					>
						{{ country.name }}
					</option>
				</select>
			</div>

			<div>
				<ButtonBlack class="mt-4" @click.native="submit">
					<div v-if="loading">
						<pulse-loader
							:loading="loading"
							:color="'#fff'"
							:size="'10px'"
						></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
			<Loader v-if="isLoading"></Loader>
		</div>
	</Container>
</template>

<script>
import { single } from '@/mixins'
import { required, maxLength } from 'vuelidate/lib/validators'
import ButtonBlack from '@/components/ButtonBlack'

export default {
	data() {
		return {
			isLoading: false,
			endpoint: 'nodes/categories',
			section: 'archivos',
			category_name: '',
			countries: [],
			currentcountry: null,
			noRole: true
		}
	},
	created() {
		this.getCountries()
	},
	methods: {
		getCountries() {
			this.$axios('conf_countries?paginate=0').then(res => {
				this.countries = res.data.data
			})
		},
		getData(data) {
			this.category_name = data.category_name
			this.currentcountry = data.country_id
		},
		getProperties() {
			return {
				category_name: this.category_name,
				country_id: this.currentcountry
			}
		}
	},
	components: {
		ButtonBlack
	},
	mixins: [single],
	validations() {
		return {
			category_name: {
				required,
				maxLength: maxLength(100)
			},
			currentcountry: {
				required
			}
		}
	}
}
</script>
